import 'reflect-metadata';
import type IApprovalRepository from '../IApprovalRepository';
import type {
  ApprovalDTO,
  ApprovalStepStatusUpdateDTO,
  ApprovalFilterDTO,
} from '../approval.types';
import { injectable } from 'inversify';
import qs from 'qs';
import API from '@repositories/Axios';
import type { Page } from '@type/Page';

@injectable()
export class ApprovalRepository implements IApprovalRepository {
  async getApprovals(filter?: ApprovalFilterDTO): Promise<Page<ApprovalDTO>> {
    const queryString = qs.stringify(filter, { arrayFormat: 'repeat' });
    const result = await API.get<Page<ApprovalDTO>>(`/api/v1/approvals?${queryString}`);
    return result.data;
  }

  async getApproval(approvalId: string): Promise<ApprovalDTO> {
    const result = await API.get<ApprovalDTO>(`/api/v1/approvals/${approvalId}`);
    return result.data;
  }

  async updateStepStatus(
    approvalId: string,
    approvalStepId: string,
    dto: ApprovalStepStatusUpdateDTO,
  ): Promise<ApprovalDTO> {
    const result = await API.patch<ApprovalDTO>(
      `/api/v1/approvals/${approvalId}/approval-steps/${approvalStepId}/status`,
      dto,
    );
    return result.data;
  }
}
